module.exports = __webpack_public_path__ + "img/pencil.46667fe2.png";